export function RecalculationsWSCtrl (
  $scope,
  $translate,
  AdminDashboard,
  confirm,
  messages,
  workshopAPI
) {

  $scope.adminDashboardApi = new AdminDashboard();

  $scope.recalculations = {
    invoice_id: '',
    get_id    : () => $scope.adminDashboardApi.get_id_for_support($scope.company)
    .then(data => {
      $scope.recalculations.invoice_id = data.record.id;
    })
  };

  $scope.recalculateBalances = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.RECALCULATE_ALL_ACCOUNT_BALANCES'))
    .then(() => workshopAPI.get('/workshop_admin/recalculate_account_balances', $scope.company.id))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.ACCOUNT_BALANCES_RECALCULATED'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.recalculateInvoiceCosts = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.RECALCULATE_ALL_INVOICE_COSTS'))
    .then(() => workshopAPI.get('/workshop_admin/recalculate_invoice_costs', $scope.company.id))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.INVOICE_COSTS_RECALCULATED'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.recalculateLaborHours = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.RECALCULATE_LABOUR_BALANCE', { company: $scope.company.company_name }))
    .then(() => workshopAPI.get('/workshop_admin/recalculate_labor_hours', [
      $scope.company.id,
      $scope.recalculations.invoice_id
    ]))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.LABOUR_HOURS_RECALCULATED'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };

}